/*
 * Шаг «Правки» при внесении сессии «правки» в старом окне сессий: все правки записаны или только часть.
 * Контракт PATCH /sessions/:id: corrections_recorded — целое ≥ 1 или null (null у записанной «правки» = все).
 */

export type CorrectionsChoice = { mode: 'all' } | { mode: 'part'; text: string };

/** Верхняя граница «Части»: четыре цифры; убирает число, которое не влезет в INTEGER в БД */
export const CORRECTIONS_PART_MAX_DIGITS = 4;
export const CORRECTIONS_PART_MAX = 10 ** CORRECTIONS_PART_MAX_DIGITS - 1;

/**
 * Что отправить в corrections_recorded. undefined — внести нельзя (число не набрано, 0 или больше назначенных).
 * `max` — правок назначено у чтеца (recordAmount); null — не указано, тогда «Все записаны» сохраняется как null.
 * «Часть» больше CORRECTIONS_PART_MAX внести нельзя.
 */
export function correctionsRecordedValue(choice: CorrectionsChoice, max: number | null): number | null | undefined {
  if (choice.mode === 'all') return max;
  const n = choice.text ? Number(choice.text) : 0;
  if (!Number.isInteger(n) || n < 1) return undefined;
  if (n > CORRECTIONS_PART_MAX) return undefined;
  if (max != null && n > max) return undefined;
  return n;
}

/**
 * Выбор при открытии шага: уже сохранённое в сессии число правок (отметку записи отменяли, поле осталось) — «Часть»,
 * иначе «Все записаны». Число, равное назначенным или больше, — это «все».
 */
export function initialCorrectionsChoice(saved: number | null | undefined, max: number | null): CorrectionsChoice {
  const isPart = typeof saved === 'number' && Number.isInteger(saved) && saved >= 1 && (max == null || saved < max);
  return isPart ? { mode: 'part', text: String(saved) } : { mode: 'all' };
}
